export default __webpack_public_path__ + "static/media/google-play-badge.ecd3aaf1.svg";